export default __webpack_public_path__ + "static/media/helpMangerAlarm.1770d82f.png";